<template>
  <div class="detail">
      <div class="detailtxt" v-if='$store.state.detail.informationText'>
          <h4>{{$store.state.detail.informationText.Title}}</h4>
          <h6>领先科技 | {{$store.state.detail.time}}</h6>
          <div class="box" v-html='$store.state.detail.informationText.HtmlContent'></div>
          <div class="next">
             <p v-if='$store.state.detail.informationText.PrevID!=null'><span>上一篇：</span><a @click="handPre($store.state.detail.informationText.PrevID)" >{{$store.state.detail.informationText.PrevTitle}}</a></p>
             <p v-if='$store.state.detail.informationText.NextID!=null'><span>下一篇：</span><a @click="handNext($store.state.detail.informationText.NextID)">{{$store.state.detail.informationText.NextTitle}}</a></p>
          </div>
      </div>
      <Popup v-show="$store.state.isshow"></Popup>
  </div>
</template>

<script>
import axios from "axios";
import tool from '@/tool/DataTool'
import router from "@/router"
import Popup from "@/components/popup"
export default {
  name: 'detail',
  data () {
    return {

    }
  },
  components: {
    Popup
   },
  methods:{
      handPre(id){
         router.push(`/informationDetail?id=${id}`);
         this.$store.commit("informationText",id)
      },
      handNext(id){
         router.push(`/informationDetail?id=${id}`);
         this.$store.commit("informationText",id)
      }
  },
  mounted(){
      this.$store.commit("informationText",this.$route.query.id)
  }
}
</script>


<style scoped>
.detail{
    margin-top:0.88rem;
    background:#fff;
}
.detail .what{
   padding-top:0.09rem;
}
.detail .detailtxt{
    width:100%;
    border-top:0.01rem solid #ccc;
    background:#fff;
    padding-bottom:0.6rem;
}
.detail .detailtxt h4{
  width:6.44rem;
  margin:0 auto;
  font:0.36rem/0.5rem 'MicrosoftYaHei';
  text-align:center;
  padding-top:0.6rem;
}
.detail .detailtxt h6{
  font:0.26rem/0.66rem 'MicrosoftYaHei';
  color:#999;
  text-align:center;
  margin-bottom:0.1rem;
}
.box{
  padding:0 0.2rem 0.5rem 0.2rem;
  border-bottom:0.01rem solid #ccc;
}
.box p img{
  width:100px;
  display:block;
  max-width:100%!important;
}
.next{
  padding-top:0.5rem;
}
.next p{
  overflow:hidden;
  padding-left:0.22rem;
}
.next p span{
  width:1.2rem;
  float:left;
  font:0.26rem/0.6rem 'MicrosoftYaHei';
  color:#666;
}
.next p a{
  width:5.64rem;
  float:left;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  font:0.26rem/0.6rem 'MicrosoftYaHei';
  color:#666;
}
</style>



// WEBPACK FOOTER //
// src/components/informationDetail.vue